module.exports = __webpack_public_path__ + "static/center-placeholder-dce583b3c49c31b1fa3c26e0b22a885b.png";